<div class="rankings-row analytics-card-host" [class.is-refreshing]="isLoading()">
  <!-- Top Requested Tunings -->
  <div class="ranking-card">
    <div class="ranking-card-header">
      <h3 class="ranking-title">Top Requested Tunings</h3>
    </div>
    <div class="ranking-table">
      <div class="table-header">
        <span class="col-rank">#</span>
        <span class="col-name">Tuning Name</span>
        <span class="col-bar">Requests</span>
        <span class="col-count"></span>
      </div>
      <div class="table-body">
        <button type="button" class="table-row tuning-row" *ngFor="let tuning of topTunings; let i = index"
                (click)="openTuningImports(tuning)" [attr.aria-label]="'View imports for ' + tuning.resellerProjectDetails">
          <span class="col-rank rank-number purple">{{ i + 1 }}</span>
          <span class="col-name row-name">{{ tuning.resellerProjectDetails }}</span>
          <span class="col-bar">
            <div class="progress-bar-track">
              <div class="progress-bar-fill purple-fill" [style.width.%]="getTuningBarWidth(tuning.countRequest)"></div>
            </div>
          </span>
          <span class="col-count row-count">{{ tuning.countRequest | number }}</span>
        </button>
        <div class="empty-state" *ngIf="!isLoading() && (!topTunings || topTunings.length === 0)">
          No data available
        </div>
      </div>
    </div>
  </div>

  <!-- Top ECU Builds -->
  <div class="ranking-card">
    <div class="ranking-card-header">
      <h3 class="ranking-title">Top ECU Builds</h3>
    </div>
    <div class="ranking-table">
      <div class="table-header">
        <span class="col-rank">#</span>
        <span class="col-name">ECU Build</span>
        <span class="col-bar">Requests</span>
        <span class="col-count"></span>
      </div>
      <div class="table-body">
        <div class="table-row" *ngFor="let ecu of topEcuBuilds; let i = index">
          <span class="col-rank rank-number amber">{{ i + 1 }}</span>
          <span class="col-name row-name">{{ ecu.ecuBuild }}</span>
          <span class="col-bar">
            <div class="progress-bar-track">
              <div class="progress-bar-fill amber-fill" [style.width.%]="getEcuBuildBarWidth(ecu.countRequest)"></div>
            </div>
          </span>
          <span class="col-count row-count">{{ ecu.countRequest | number }}</span>
        </div>
        <div class="empty-state" *ngIf="!isLoading() && (!topEcuBuilds || topEcuBuilds.length === 0)">
          No data available
        </div>
      </div>
    </div>
  </div>
</div>
